var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewsSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,2H9C7.8974609,2,7,2.8974609,7,4v2H4C2.8974609,6,2,6.8974609,2,8v19c0,1.6542969,1.3457031,3,3,3h22 c1.6542969,0,3-1.3457031,3-3V4C30,2.8974609,29.1025391,2,28,2z M28,27c0,0.5517578-0.4482422,1-1,1H5 c-0.5517578,0-1-0.4482422-1-1V8h3v16h2V4h19V27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,14h9c1.1025391,0,2-0.8974609,2-2V9c0-1.1025391-0.8974609-2-2-2h-9c-1.1025391,0-2,0.8974609-2,2v3 C12,13.1025391,12.8974609,14,14,14z M14,9h9l0.0019531,3H14V9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 17,
    width: 13,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22,
    width: 13,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsSmall);
export default __webpack_public_path__ + "static/media/news--small.67c84be67d397da0893a0fc09de617f8.svg";
export { ForwardRef as ReactComponent };